// 422: the server rejected the pixels; the message is its reason, when it sent one.
export class ConversionError extends Error {
  name = "ConversionError"
}

// 429: the per-IP conversion limit.
export class RateLimitError extends Error {
  name = "RateLimitError"
}
